<template>
    <span v-if="canCancel" v-loading="loading">
        <button class="btn btn-outline-danger btn-sm cancel-quote-request-btn" title="Cancel the client's quote request"
            :disabled="loading" @click="confirmCancel">
            <i class="fa fa-times-circle"></i> Cancel Quote Request
        </button>
    </span>
</template>

<script>
import QuoteService from "@/services/quote.service";
import { MessageBox, Message } from "element-ui";

export default {
    name: "CancelQuoteRequest",
    props: {
        leadEvent: {
            type: Object,
            required: true,
        },
        venue: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        canCancel() {
            // Show only when a quote request exists for this venue AND it has not
            // already been cancelled. If a quote has already been accepted the
            // backend will reject with 409, which we surface with a friendly copy.
            return !!(
                this.venue &&
                this.venue.isQuoteRequested &&
                !this.venue.isQuoteRequestCancelled
            );
        },
    },
    methods: {
        async confirmCancel() {
            const venueName = this.venue?.name || "this venue";
            try {
                await MessageBox.confirm(
                    `This will cancel the client's quote request for ${venueName}. Continue?`,
                    "Cancel Quote Request",
                    {
                        confirmButtonText: "Yes, Cancel Request",
                        cancelButtonText: "Back",
                        type: "warning",
                    }
                );
            } catch (_) {
                return;
            }

            await this.cancelQuoteRequest();
        },

        async cancelQuoteRequest() {
            this.loading = true;
            try {
                await QuoteService.cancelQuoteRequestByRep(
                    this.leadEvent.lead_id,
                    this.leadEvent.id,
                    this.venue.id,
                    !!this.venue.isCustomVenue
                );
                Message.success("Quote request cancelled.");
                this.$emit("update");
            } catch (error) {
                this.handleError(error);
            } finally {
                this.loading = false;
            }
        },

        handleError(error) {
            const status = error?.response?.status;
            const serverMessage = error?.response?.data?.message;

            if (status === 404) {
                Message.error(
                    serverMessage
                    || "No quote request was found for this venue on this event."
                );
                return;
            }

            if (status === 409) {
                Message.error(
                    serverMessage
                    || "The quote request can no longer be cancelled because the quote has already been accepted."
                );
                return;
            }

            console.error("Error cancelling quote request:", error);
            Message.error(serverMessage || "Failed to cancel the quote request. Please try again.");
        },
    },
};
</script>

<style scoped>
.cancel-quote-request-btn {
    font-size: 12px;
    padding: 4px 8px;
    margin-left: 6px;
}
</style>
